__turbopack_context__.v({
  "container": "LoadingView-module-scss-module__ydYL0a__container",
  "enter": "LoadingView-module-scss-module__ydYL0a__enter",
  "exit": "LoadingView-module-scss-module__ydYL0a__exit",
  "fade-in": "LoadingView-module-scss-module__ydYL0a__fade-in",
  "fade-out": "LoadingView-module-scss-module__ydYL0a__fade-out",
  "fade-out-80": "LoadingView-module-scss-module__ydYL0a__fade-out-80",
  "loading-view-spin": "LoadingView-module-scss-module__ydYL0a__loading-view-spin",
  "message": "LoadingView-module-scss-module__ydYL0a__message",
  "slide-in-from-bottom": "LoadingView-module-scss-module__ydYL0a__slide-in-from-bottom",
  "slide-in-from-left": "LoadingView-module-scss-module__ydYL0a__slide-in-from-left",
  "slide-in-from-right": "LoadingView-module-scss-module__ydYL0a__slide-in-from-right",
  "slide-in-from-top": "LoadingView-module-scss-module__ydYL0a__slide-in-from-top",
  "slide-out-to-bottom": "LoadingView-module-scss-module__ydYL0a__slide-out-to-bottom",
  "slide-out-to-left": "LoadingView-module-scss-module__ydYL0a__slide-out-to-left",
  "slide-out-to-right": "LoadingView-module-scss-module__ydYL0a__slide-out-to-right",
  "slide-out-to-top": "LoadingView-module-scss-module__ydYL0a__slide-out-to-top",
  "spinner": "LoadingView-module-scss-module__ydYL0a__spinner",
  "zoom-in": "LoadingView-module-scss-module__ydYL0a__zoom-in",
  "zoom-out": "LoadingView-module-scss-module__ydYL0a__zoom-out",
});
